export default __webpack_public_path__ + "static/2.5.1/media/nationalCentreResearchAndDevelopment.683c322c.svg";